(function () {
  var rebindTimer = null;
  var retryTimer = null;

  function getUnboundWidgets(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('div[data-sc-id][data-sc-type="SmartButton"]');
    var unbound = [];

    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].childElementCount) {
        unbound.push(nodes[i]);
      }
    }

    return unbound;
  }

  function constrainCtaButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll(
      '.product-item__find-more-retailers-button--smartcommerce button.sc-btn-ec, .product__find-more-retailers-button--smartcommerce button.sc-btn-ec'
    );
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 719px)').matches;

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];

      button.style.setProperty('max-width', '100%', 'important');
      button.style.setProperty('min-width', '0', 'important');
      button.style.setProperty('box-sizing', 'border-box', 'important');

      if (isMobile) {
        button.style.setProperty('width', '100%', 'important');
        button.style.setProperty('white-space', 'normal', 'important');
        button.style.setProperty('overflow-wrap', 'break-word', 'important');
        button.style.setProperty('word-break', 'normal', 'important');
        button.style.setProperty('height', 'auto', 'important');
        button.style.setProperty('max-height', 'none', 'important');
        button.style.setProperty('overflow', 'visible', 'important');
        button.style.setProperty('text-overflow', 'clip', 'important');
        button.style.setProperty('line-height', '1.3', 'important');
      }
    }
  }

  function rebindSmartCommerceWidgets(root) {
    if (!window.SmartCart || typeof window.SmartCart.loadSmartSiteElements !== 'function') {
      return false;
    }

    var unbound = getUnboundWidgets(root);

    if (!unbound.length) {
      constrainCtaButtons(root);
      return true;
    }

    window.SmartCart.loadSmartSiteElements(unbound);
    // SmartCommerce paints buttons async after loadSmartSiteElements.
    setTimeout(function () {
      constrainCtaButtons(root);
    }, 50);
    setTimeout(function () {
      constrainCtaButtons(root);
    }, 300);
    return true;
  }

  function scheduleRebind(root) {
    clearTimeout(rebindTimer);
    clearInterval(retryTimer);

    rebindTimer = setTimeout(function () {
      if (rebindSmartCommerceWidgets(root)) {
        return;
      }

      // SmartCart loads async; retry briefly until it is available.
      var attempts = 0;
      retryTimer = setInterval(function () {
        attempts += 1;

        if (rebindSmartCommerceWidgets(root) || attempts > 40) {
          clearInterval(retryTimer);
        }
      }, 100);
    }, 50);
  }

  // Allow other scripts (recommendations, grids, etc.) to request a rebind.
  window.rebindSmartCommerceWidgets = scheduleRebind;

  document.addEventListener('product:variant-change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    var widgets = document.querySelectorAll(
      '.product__find-more-retailers [data-sc-id][data-sc-type="SmartButton"]'
    );

    if (!widgets.length || !variant) {
      return;
    }

    var upc = variant.barcode || variant.sku || '';

    for (var i = 0; i < widgets.length; i++) {
      widgets[i].setAttribute('data-sc-upc', upc);
      // Clear rendered children so SmartCart rebinds against the new UPC.
      widgets[i].innerHTML = '';
    }

    scheduleRebind();
  });

  // Recommendations already dispatch this when Wayvia is absent.
  document.addEventListener('wayvia:rebind', function () {
    scheduleRebind();
  });
  document.addEventListener('shopify:section:load', function () {
    scheduleRebind();
  });

  // PLP/search filters and infinite scroll replace product cards via AJAX.
  function subscribeToCollectionUpdates() {
    if (typeof window.on !== 'function') {
      return false;
    }

    window.on('collection:updated', function () {
      scheduleRebind();
    });
    return true;
  }

  function hasUnboundWidgets(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    if (
      node.matches &&
      node.matches('div[data-sc-id][data-sc-type="SmartButton"]') &&
      !node.childElementCount
    ) {
      return true;
    }

    return !!(
      node.querySelector &&
      node.querySelector('div[data-sc-id][data-sc-type="SmartButton"]:empty')
    );
  }

  function observeDomForWidgets() {
    if (typeof MutationObserver !== 'function') {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var needsRebind = false;
      var needsConstrain = false;

      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;

        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (hasUnboundWidgets(node)) {
            needsRebind = true;
          }
          if (
            node &&
            node.nodeType === 1 &&
            ((node.matches && node.matches('button.sc-btn-ec')) ||
              (node.querySelector && node.querySelector('button.sc-btn-ec')))
          ) {
            needsConstrain = true;
          }
        }
      }

      if (needsRebind) {
        scheduleRebind();
      } else if (needsConstrain) {
        constrainCtaButtons();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    if (!subscribeToCollectionUpdates()) {
      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (subscribeToCollectionUpdates() || attempts > 40) {
          clearInterval(timer);
        }
      }, 50);
    }

    observeDomForWidgets();
    scheduleRebind();
    bindOpenState();
    constrainCtaButtons();
    window.addEventListener('resize', function () {
      constrainCtaButtons();
    });
  }

  function clearOpenState() {
    var openNodes = document.querySelectorAll('.is-smartcommerce-open');
    for (var i = 0; i < openNodes.length; i++) {
      openNodes[i].classList.remove('is-smartcommerce-open');
    }
  }

  function closeRetailerPanels() {
    var panels = document.querySelectorAll('.sc-btn-retailer-wrapper, div[id^="sc-rd"]');
    for (var i = 0; i < panels.length; i++) {
      panels[i].style.display = 'none';
    }
    clearOpenState();
  }

  function isInsideSmartCommerceUi(target) {
    return !!(
      target.closest &&
      target.closest(
        [
          '.product-item__find-more-retailers-button--smartcommerce',
          '.product__find-more-retailers-button--smartcommerce',
          '.sc-btn-retailer-wrapper',
          'div[id^="sc-rd"]',
          '#smart-cart',
        ].join(', ')
      )
    );
  }

  function bindOpenState() {
    document.addEventListener('click', function (evt) {
      var target = evt.target;
      if (!target || !target.closest) {
        return;
      }

      // Click outside SmartCommerce UI → close retailer modal.
      if (!isInsideSmartCommerceUi(target)) {
        closeRetailerPanels();
        return;
      }

      var widget = target.closest(
        '.product-item__find-more-retailers-button--smartcommerce, .product__find-more-retailers-button--smartcommerce'
      );

      if (!widget) {
        return;
      }

      // Clicking the CTA: SmartCommerce toggles its own panel; keep z-index in sync.
      clearOpenState();
      var host = widget.closest('.product-item, .product__find-more-retailers');
      if (host) {
        host.classList.add('is-smartcommerce-open');
      }

      setTimeout(function () {
        var panel = widget.querySelector('.sc-btn-retailer-wrapper, div[id^="sc-rd"]');
        if (panel && panel.style.display === 'none') {
          clearOpenState();
        }
      }, 0);
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' || evt.keyCode === 27) {
        closeRetailerPanels();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
